/**
 * core.js — shared helpers, feature flags, smooth scroll and runtime strings.
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);
export { gsap, ScrollTrigger };

export const $ = (s, c = document) => c.querySelector(s);
export const $$ = (s, c = document) => [...c.querySelectorAll(s)];
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
export const pad = (n, l = 2) => String(n).padStart(l, "0");

export const root = document.documentElement;
export const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
export const finePointer = matchMedia("(pointer: fine)").matches;
root.classList.add("js");
if (!reduce) root.classList.add("anim");       // .anim gates every hide-then-reveal state in CSS

/** strings + data the page embedded for us (see render.mjs → runtime()) */
export const RT = JSON.parse($("#rt")?.textContent || "{}");

export const navH = () => $("#nav")?.offsetHeight || 64;

// smooth scroll (off for reduced motion — native scrolling then)
export let lenis = null;
if (!reduce) {
  lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 0.95 });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((t) => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
}

/** scroll to an element, offset for the fixed nav; moves keyboard focus there too */
export function goTo(el, focus = true) {
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -navH(), duration: 1.2 });
  else el.scrollIntoView({ block: "start" });
  if (focus && el.id !== "top") { if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1"); el.focus({ preventScroll: true }); }
}

// every in-page link goes through goTo (links like /#kaart on sub-pages keep native behaviour)
document.addEventListener("click", (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute("href");
  const el = id === "#top" ? document.body : $(id);
  if (!el) return;
  e.preventDefault();
  document.dispatchEvent(new CustomEvent("rhino:navigate", { detail: { a, id } }));
  goTo(el, id !== "#top");
  history.pushState(null, "", id);
});
